import React, { useEffect } from "react";
import NavigationList from "./NavigationList";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import * as ProjectActions from "../../store/project/projectSlice";

export default function Navigation({ items }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentProject = items.find((item) =>
    location.pathname.includes(item.linkPath)
  );
  const isHiddenNavigation = currentProject.isHiddenNavigation;

  useEffect(() => {
    const project = items.find((item) =>
      location.pathname.includes(item.linkPath)
    );
    const projectType = project?.projectType;
    dispatch(ProjectActions.setProjectType(projectType));
  }, [location.pathname]);

  return (
    <>
      {items.length > 1 && !isHiddenNavigation && (
        <div className="app-project-types app-header">
          <div className="app-container">
            <NavigationList items={items} />
          </div>
        </div>
      )}
    </>
  );
}
